import { FirestoreCollectionNames } from "shared/firestore";
import { IApplication } from "shared/model/IApplication";
import { IApplicationPublicEvents } from "shared/model/IApplicationPublicEvents";

import FirestoreListObserver from "./FirestoreListObserver";
import FirestoreObserver from "./FirestoreObserver";

export default class FirestoreObserverFactory {
  public static publicEventsObserver(applicationId: string) {
    return new FirestoreObserver<IApplicationPublicEvents>([
      FirestoreCollectionNames.PublicEvents,
      applicationId
    ]);
  }

  public static applicationObserver(coworkName: string, applicationId: string) {
    return new FirestoreObserver<IApplication>([
      FirestoreCollectionNames.CoworkingSpaces,
      coworkName,
      FirestoreCollectionNames.Applications,
      applicationId
    ]);
  }

  public static applicationsListObserver(coworkName: string) {
    return new FirestoreListObserver<IApplication>([
      FirestoreCollectionNames.CoworkingSpaces,
      coworkName,
      FirestoreCollectionNames.Applications
    ]);
  }
}



// WEBPACK FOOTER //
// ./src/services/firebase/database/observers/FirestoreObserverFactory.ts